import ReservationSlot from './ReservationSlot';

export default ReservationSlot;
